// src/components/MenuScreen.js
import React from 'react';
import { useKiosk } from '../context/KioskContext';
import { Plus, ShoppingCart } from 'lucide-react';
import './MenuScreen.css';

const MenuScreen = ({ onNext }) => {
  const { menuItems, addToOrder, currentOrder, getTotalPrice } = useKiosk();

  const handleFinishOrder = () => {
    if (currentOrder.length > 0) {
      onNext();
    }
  };

  return (
    <div className="menu-screen">
      {/* Animated Background Elements */}
      <div className="bg-element bg-element-1" />
      <div className="bg-element bg-element-2" />

      {/* Header with Logo */}
      <div className="menu-header">
        <div className="heysalad-logo">
          <img src="/HeySalad Logo White.png" alt="HeySalad" className="logo-image" />
        </div>
        <h1 className="menu-title">Our Menu</h1>
        <p className="menu-subtitle">Fresh, healthy choices made just for you</p>
      </div>

      {/* Menu Items Grid */}
      <div className="menu-grid">
        {menuItems.map(item => (
          <div key={item.id} className="menu-item-card">
            {item.image && (
              <div className="item-image">
                <img src={item.image} alt={item.name} />
              </div>
            )}
            <div className="menu-item-content">
              <div className="menu-item-header">
                <h3 className="item-name">{item.name}</h3>
                <span className="item-price">£{item.price}</span>
              </div>
              <p className="item-description">{item.description}</p>
              <div className="item-details">
                <span className="item-calories">{item.calories} cal</span>
                <div className="dietary-tags">
                  {item.dietary.map(tag => (
                    <span key={tag} className="dietary-tag">{tag}</span>
                  ))}
                </div>
              </div>
              <div className="nutrition-info">
                <span className="protein">Protein: {item.protein}g</span>
                <span className="fiber">Fiber: {item.fiber}g</span>
              </div>
              <button 
                onClick={() => addToOrder(item)}
                className="add-to-order-button"
              >
                <Plus size={20} />
                Add to Order
              </button>
            </div>
          </div>
        ))}
      </div>

      {/* Floating Basket */}
      {currentOrder.length > 0 && (
        <div className="floating-basket">
          <div className="basket-content">
            <div className="basket-info">
              <ShoppingCart size={20} />
              <span className="basket-count">{currentOrder.length} items</span>
              <span className="basket-total">£{getTotalPrice()}</span>
            </div>
            <button 
              onClick={handleFinishOrder}
              className="finish-order-button"
            >
              Finish Order
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuScreen;